import { store } from "@/config"

export const isSharedInventoryEnabled = () => {
  return store.getters.currentOrganization.shared_inventory_enabled
}

export const isNicolasEnabled = () => {
  return store.getters.isNicolasEnabled
}
